// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VXKz","type":"styles_type__2cwSy","choices":"styles_choices__EMASw"};